import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import _ from 'lodash';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';

// Adonde lleva "/": el perfil Cliente solo tiene su portal; el resto entra a Viajes, como siempre.
// Mira los perfiles de la compania activa, igual que el menu y que Ability en el backend.
export const isClientOnlyUser = (user) => {
    if (!user?.profiles?.length) return false;
    if (_.some(user.profiles, { name: 'superadmin' })) return false;

    const currentCompanyId = user?.current_company?.id ?? user?.current_company_id;
    const current = currentCompanyId
        ? _.filter(user.profiles, (p) => `${p.company_id}` === `${currentCompanyId}`)
        : user.profiles;
    return current.length > 0 && _.every(current, { name: 'client' });
};

const HomeRedirect = () => {
    const { authUser, authToken, isLoading } = useJumboAuth();

    // El usuario llega despues del primer render (JumboAuthProvider lo pide con el token que
    // ya tiene guardado). Decidir antes mandaba siempre a Viajes, y el perfil Cliente se comia
    // un 403 apenas entraba.
    if (isLoading || (authToken && !authUser)) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
                <CircularProgress />
            </Box>
        );
    }

    return <Navigate to={isClientOnlyUser(authUser) ? '/mis-pedidos' : '/trips'} replace />;
};

export default HomeRedirect;
